import { FC } from "react"

import ReservationArticle from "models/ReservationArticle"
import { Purpose } from "config/constants"
import ArticleWithAssets from "components/ArticleWithAssets/ArticleWithAssets"
import { Guid } from "@/types"
import ReservationAsset from "models/ReservationAsset"

interface IShippingOrderModalArticlesProps {
    shippingOrderAssetIds: Guid[]
    nodeArticleId: Guid
    reservationArticles: ReservationArticle[]
    purpose: Purpose
}

const ShippingOrderArticles: FC<IShippingOrderModalArticlesProps> = ({
    shippingOrderAssetIds,
    nodeArticleId,
    reservationArticles,
    purpose,
}) => {
    function filterAssets(reservationAssets: ReservationAsset[]) {
        return reservationAssets.filter(asset => asset.assetId && shippingOrderAssetIds.includes(asset.assetId))
    }

    function renderArticle(article: ReservationArticle, index: number) {
        const assets = filterAssets(article.assets)
        if (assets.length === 0) return null
        return (
            <div key={index} className="py-1 border-grey-100-between">
                <ArticleWithAssets
                    article={article}
                    isNodeArticle={article.articleId === nodeArticleId}
                    assets={assets}
                    assetCount={assets.length}
                    purpose={purpose}
                    showLmidForAutomaticAssets
                    clickableLmid
                />
            </div>
        )
    }

    return <>
        {reservationArticles.map(renderArticle)}
    </>
}

export default ShippingOrderArticles
